/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationUser } from './ApplicationUser';
import {
    ApplicationUserFromJSON,
    ApplicationUserFromJSONTyped,
    ApplicationUserToJSON,
    ApplicationUserToJSONTyped,
} from './ApplicationUser';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';
import type { BlobFileType } from './BlobFileType';
import {
    BlobFileTypeFromJSON,
    BlobFileTypeFromJSONTyped,
    BlobFileTypeToJSON,
    BlobFileTypeToJSONTyped,
} from './BlobFileType';

/**
 * 
 * @export
 * @interface FileUpload
 */
export interface FileUpload {
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpload
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FileUpload
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FileUpload
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    originalFileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileUpload
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    blobUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    contentType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileUpload
     */
    fileSizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    containerName?: string | null;
    /**
     * 
     * @type {BlobFileType}
     * @memberof FileUpload
     */
    fileType?: BlobFileType;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof FileUpload
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    uploadedByUserId?: string;
    /**
     * 
     * @type {ApplicationUser}
     * @memberof FileUpload
     */
    uploadedByUser?: ApplicationUser;
    /**
     * 
     * @type {string}
     * @memberof FileUpload
     */
    importSessionId?: string | null;
    /**
     * 
     * @type {ImportSession}
     * @memberof FileUpload
     */
    importSession?: ImportSession;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FileUpload
     */
    metadata?: { [key: string]: string; } | null;
}



/**
 * Check if a given object implements the FileUpload interface.
 */
export function instanceOfFileUpload(value: object): value is FileUpload {
    return true;
}

export function FileUploadFromJSON(json: any): FileUpload {
    return FileUploadFromJSONTyped(json, false);
}

export function FileUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileUpload {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'originalFileName': json['originalFileName'] == null ? undefined : json['originalFileName'],
        'order': json['order'] == null ? undefined : json['order'],
        'blobUrl': json['blobUrl'] == null ? undefined : json['blobUrl'],
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'fileSizeBytes': json['fileSizeBytes'] == null ? undefined : json['fileSizeBytes'],
        'containerName': json['containerName'] == null ? undefined : json['containerName'],
        'fileType': json['fileType'] == null ? undefined : BlobFileTypeFromJSON(json['fileType']),
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'uploadedByUserId': json['uploadedByUserId'] == null ? undefined : json['uploadedByUserId'],
        'uploadedByUser': json['uploadedByUser'] == null ? undefined : ApplicationUserFromJSON(json['uploadedByUser']),
        'importSessionId': json['importSessionId'] == null ? undefined : json['importSessionId'],
        'importSession': json['importSession'] == null ? undefined : ImportSessionFromJSON(json['importSession']),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function FileUploadToJSON(json: any): FileUpload {
    return FileUploadToJSONTyped(json, false);
}

export function FileUploadToJSONTyped(value?: FileUpload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'fileName': value['fileName'],
        'originalFileName': value['originalFileName'],
        'order': value['order'],
        'blobUrl': value['blobUrl'],
        'contentType': value['contentType'],
        'fileSizeBytes': value['fileSizeBytes'],
        'containerName': value['containerName'],
        'fileType': BlobFileTypeToJSON(value['fileType']),
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'uploadedByUserId': value['uploadedByUserId'],
        'uploadedByUser': ApplicationUserToJSON(value['uploadedByUser']),
        'importSessionId': value['importSessionId'],
        'importSession': ImportSessionToJSON(value['importSession']),
        'metadata': value['metadata'],
    };
}

